import React from "react";
import {
  StyledDropdownsContainer,
  StyledFilterWrapper,
  StyledRotaDropdownHeader,
  StyledSeparator
} from "../po-numbers.styles";
import { RotaDropdownHeader, RotaMultiSelectMenu } from "@teamrota/rota-design";
import { filterBySearchTerm, isLastItem } from "../utils";

const POFilter = ({
  filters,
  openDropdowns,
  toggleDropdown,
  handleSearch,
  handleSelect,
  handleClear,
  dropdownOptions,
  isAnyFilterSelected
}) => {
  const filtersArray = Object.values(filters);
  const nonSearchableFilters = [
    "shiftStatusFilter",
    "shiftTypesFilter",
    "shiftSourcesFilter",
    "createdAfterFilter"
  ];

  return (
    <StyledFilterWrapper>
      <RotaDropdownHeader
        labelText={"Filter by..."}
        isOpen={openDropdowns.main}
        setIsOpen={() => toggleDropdown("main")}
        shouldShowDot={isAnyFilterSelected}
      >
        <StyledDropdownsContainer>
          {filtersArray.map(
            ({ name, displayName, searchPlaceholder }, index) => {
              const showSearchInput = !nonSearchableFilters.includes(name);
              const filteredItems = filterBySearchTerm(
                dropdownOptions[name] || [],
                filters[name]?.searchTerm || ""
              );
              return (
                <div key={name}>
                  <StyledRotaDropdownHeader
                    labelText={displayName.toUpperCase()}
                    isOpen={openDropdowns[name]}
                    setIsOpen={() => toggleDropdown(name)}
                    shouldShowDot={!!filters[name]?.selectedItems.length}
                    opensToRight
                    onClose={() => handleSearch("", name)}
                    searchPlaceholder={searchPlaceholder}
                  >
                    <RotaMultiSelectMenu
                      items={filteredItems}
                      onSearch={value => handleSearch(value, name)}
                      onSelect={item => handleSelect(item, name)}
                      onClear={() => handleClear(name)}
                      showSearchInput={showSearchInput}
                    />
                  </StyledRotaDropdownHeader>
                  {!isLastItem(filtersArray, index) && <StyledSeparator />}
                </div>
              );
            }
          )}
        </StyledDropdownsContainer>
      </RotaDropdownHeader>
    </StyledFilterWrapper>
  );
};

export default POFilter;
